import { createAction, handleActions } from 'redux-actions';
import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { fromJS, List } from 'immutable';
import ReactOnRails from 'react-on-rails';

import { post } from '../lib/Api';

const IMPORT_JSON_REQUESTED = 'IpRestriction/IMPORT_JSON_REQUESTED';
const IMPORT_JSON_SUCCEEDED = 'IpRestriction/IMPORT_JSON_SUCCEEDED';
const IMPORT_JSON_FAILED = 'IpRestriction/IMPORT_JSON_FAILED';
const ADD_FORM = 'IpRestriction/ADD_FORM';
const REMOVE_FORM = 'IpRestriction/REMOVE_FORM';
const UPDATE_FORM = 'IpRestriction/UPDATE_FORM';

export const actions = {
  importJsonRequested: createAction(IMPORT_JSON_REQUESTED, (body) => ({ body })),
  importJsonSucceeded: createAction(IMPORT_JSON_SUCCEEDED, (ipRestrictions) => ({ ipRestrictions })),
  importJsonFailed: createAction(IMPORT_JSON_FAILED, (message) => ({ message })),
  addForm: createAction(ADD_FORM),
  removeForm: createAction(REMOVE_FORM, (index) => ({ index })),
  updateForm: createAction(UPDATE_FORM, (index, key, value) => ({ index, key, value })),
};

export const $$initialState = fromJS({
  requesting: false,
  errors: '',
  ip_restrictions: new List(),
  import_size: null,
});

const reducer = handleActions({
  [IMPORT_JSON_REQUESTED]: ($$state) => $$state.set('requesting', true),
  [IMPORT_JSON_SUCCEEDED]: ($$state, action) => $$state.merge({
    requesting: false,
    ip_restrictions: fromJS(action.payload.ipRestrictions),
    errors: '',
  }),
  [IMPORT_JSON_FAILED]: ($$state, action) => $$state.merge({
    requesting: false,
    errors: action.payload.message,
  }),
  [ADD_FORM]: ($$state) => $$state.update('ip_restrictions', (e) => e.push(fromJS({ ip_addr: '', note: '' }))),
  [REMOVE_FORM]: ($$state, action) => $$state.deleteIn(['ip_restrictions', action.payload.index]),
  [UPDATE_FORM]: ($$state, action) => {
    const { index, key, value } = action.payload;
    return $$state.setIn(['ip_restrictions', index, key], value);
  },
}, $$initialState);

export default reducer;

function* importJson(action) {
  // /(data_topics|news_topics)/xx/ip_restrictions/new
  // もしくは
  // /(data_topics|news_topics)/xx/ip_restrictions
  // から叩かれるので、このパスから
  // /(data_topics|news_topics)/xx/ip_restrictions/import_json を作る
  const url = `${location.pathname.split(/\/new$/)[0]}/import_json`;
  const csrfToken = ReactOnRails.authenticityToken();
  const body = action.payload.body;

  try {
    const ipRestrictions = yield call(post, url, body, csrfToken);

    if (ipRestrictions.error) {
      yield put(actions.importJsonFailed(ipRestrictions.error));
    } else {
      yield put(actions.importJsonSucceeded(ipRestrictions));
    }
  } catch (exception) {
    yield put(actions.importJsonFailed(exception.message));
  }
}

function* importJsonSaga() {
  yield takeEvery(IMPORT_JSON_REQUESTED, importJson);
}

export function* ipRestrictionFormSaga() {
  yield fork(importJsonSaga);
}
